import EmptyCard from "@/components/UI/EmptyPages/EmptyCard";

const FeedbackRatings = () => (
  <EmptyCard
    title="Feedback & Ratings is coming soon"
    subtitle="This module is not built yet. Check back later."
  />
);

export default FeedbackRatings;
